@if (open()) {
  <div class="scrim" data-testid="account-scrim" (click)="close.emit()"></div>

  <div class="panel" data-testid="account-panel" role="dialog" aria-label="Account">
    <!--
      Theme and text size are per-browser preferences, not account settings --
      they work with no session and a signed-out reader has the same eyes. Sits
      outside the sign-in/account-menu split below so both viewers get it.
    -->
    <div data-testid="account-theme">
      <div class="panel-row">
        <span>Appearance</span>
        <button
          type="button"
          class="row-action"
          data-testid="appearance-toggle"
          [attr.aria-label]="theme.theme() === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'"
          (click)="theme.toggleTheme()">
          <span data-testid="appearance-value">{{ appearance() }}</span>
          <ng-icon [name]="theme.theme() === 'dark' ? 'lucideSun' : 'lucideMoon'" />
        </button>
      </div>

      <div class="sizes">
        <p class="eyebrow">Text size</p>
        <div class="size-grid">
          @for (choice of textSizes; track choice.value) {
            <button
              type="button"
              class="size-card"
              [class.selected]="theme.textSize() === choice.value"
              [attr.data-testid]="'text-size-' + choice.value"
              [attr.aria-pressed]="theme.textSize() === choice.value"
              (click)="theme.setTextSize(choice.value)">
              <span [class]="'sample sample--' + choice.value">{{ choice.label }}</span>
            </button>
          }
        </div>
      </div>
    </div>

    @if (user(); as user) {
      <div data-testid="account-menu">
        <div class="head">
          <p class="name">{{ user.name || user.username }}</p>
          <p class="sub">{{ user.company }}</p>
        </div>

        <!--
          Back to the old app. Was a bare "Classic" in the top bar, which named
          the destination and not the action -- a word on its own beside the
          account icon, with no way to tell whether it was a link, a mode or a
          status. In here it can afford a sentence, and it sits with the other
          preferences, which is what choosing a layout is.

          Temporary, on both sides: this and the "Try the new layout" link in
          the old sidebar come out at cutover.
        -->
        @if (classicHref) {
          <!-- Off this origin: the classic app is the estimator host's. -->
          <a
            class="row-btn"
            data-testid="account-classic"
            [href]="classicHref"
            (click)="close.emit()">
            Switch to the classic layout
          </a>
        } @else {
          <a
            class="row-btn"
            data-testid="account-classic"
            routerLink="/classic"
            (click)="close.emit()">
            Switch to the classic layout
          </a>
        }

        <button type="button" class="row-btn" data-testid="account-signout" (click)="onLogout()">
          Sign out
        </button>
      </div>
    } @else {
      <!--
        No session. Sign-in lives on the estimator origin only, so from the
        briefings host this is a cross-origin link carrying a return address
        (`signInHref()`, same shape as `AuthGuard.sendToLogin`) rather than a
        `routerLink` -- exactly the split `classicHref` already makes above,
        for the same reason.
      -->
      @if (signInHref(); as href) {
        <a class="row-btn" data-testid="account-sign-in" [href]="href" (click)="close.emit()">
          Sign in
        </a>
      } @else {
        <a
          class="row-btn"
          data-testid="account-sign-in"
          routerLink="/login"
          (click)="close.emit()">
          Sign in
        </a>
      }
    }
  </div>
}
